import FrameBrowser from './FrameBrowser'

export default FrameBrowser
